import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { UserRegiester } from "./registeration/user-registeration";
import { GenOTPRequest } from "./registeration/gen-otp-request";
import { VerifyOtpRequest } from "./otp/verify-otp-request";
import { RecoverPasswordReq } from "./recover-password/recover-password-req";
import { UniqueVisitorRequest } from "./header/uniqueVisitorRequest";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { CheckUser } from "./registeration/check-user";
import { AccountService } from "./auth/account.service";
import { PopUpService } from "./PopUpService";
import { DataStorageService } from "./data-storage.service";

@Injectable()
export class SharedService {
    constructor(public http: HttpClient,
        private $localStorage: LocalStorageService,
        private accountSer: AccountService,
        private popupservice: PopUpService,
        private dataStorage: DataStorageService,
        private $sessionStorage: SessionStorageService, ) { }
    checkuser: CheckUser;

    getOTP(genotp: GenOTPRequest): any {
        const otp_json = JSON.stringify(genotp);
        return this.http.post("/patron/user/register/otp", otp_json, { observe: 'response' });
    }

    verifyOTP(verifyotp: VerifyOtpRequest): any {
        const otp_json = JSON.stringify(verifyotp);
        return this.http.post("/patron/user/register/otp/verify", otp_json, { observe: 'response' });
    }

    registerUser
        (userRegiester: UserRegiester): any {
        const user_json = JSON.stringify(userRegiester);
        return this.http.post("/patron/user/register/user", user_json, { observe: 'response' });
    }

    getUser(username: string): any {
        this.checkuser = new CheckUser();
        this.checkuser.userId = username;
        return this.http.post("/patron/user/check/", JSON.stringify(this.checkuser), { observe: 'response' });
    }

    getEkpayUser(username: string): any {
        return this.http.get("/patron/user/get/" + username, { observe: 'response' });
    }

    recoverPassword(recoverPassword: RecoverPasswordReq): any {
        const recoverPasswordJson = JSON.stringify(recoverPassword);
        return this.http.post("/patron/user/password/forget", recoverPasswordJson, { observe: 'response' });
    }

    uniqueVisitor(uniqueVisitor: UniqueVisitorRequest): any {
        return this.http.post("/patron/access/visitor", JSON.stringify(uniqueVisitor), { observe: 'response' });
    }

    getCapcha(): any {
        return this.http.get("/patron/open/get/captcha", { responseType: 'text' });
    }

    validateCapcha(captcha): any {
        return this.http.get("/patron/open/valid/captcha?captcha=" + captcha, { responseType: 'text' });
    }

    getOtpAuthentication(verifyotp: VerifyOtpRequest): any {
        return this.http.post("/patron/api/otp/authenticate", JSON.stringify(verifyotp), { observe: 'response' });
    }
    refreshData() {
        //if session expired but token exist, then we clear token and logout user.
        if (localStorage.getItem("user") === 'undefined') {
            this.$localStorage.clear('authenticationToken');
            this.$sessionStorage.clear('authenticationToken');
            // this.popupservice.logout();
        }
        // console.log('refreshed data>>>');
        // this.accountSer.get().toPromise().then((account) => {
        //     console.log('account >>>>', account);
        // }).catch((err) => {
        //     console.log('Error >>>>>>>>', err);
        //     if (localStorage.getItem("user") === null) {
        //         this.popupservice.logout();
        //     }
        //     this.$localStorage.clear('authenticationToken');
        //     this.$sessionStorage.clear('authenticationToken');
        //     this.dataStorage.setUserData(null);
        //     this.dataStorage.setLangData(null);
        // });
        //this.subcription = Observable.timer(5000).subscribe(() => this.refreshData());
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts